// extracted by mini-css-extract-plugin
module.exports = {"tab":"ProfileTab_tab__eQhmD","title":"ProfileTab_title__8abI9","sub-title":"ProfileTab_sub-title__KtXcz","active":"ProfileTab_active__GtPjr"};